import { PROFILE_COMPLETION_PENDING, PROFILE_REVIEW } from "@/components/shared/partners/registration-status/data"
import ProfileCompletionPending from "@/components/home/partner/profile-completion-pending/Index.vue"
import ProfileReview from "@/components/home/partner/profile-review/Index.vue"

export default {
  partner: {
    [PROFILE_COMPLETION_PENDING]: {
      availableRoutes: ["profile", "home-page", "system-unreachable"],
      component: ProfileCompletionPending,
    },
    [PROFILE_REVIEW]: {
      availableRoutes: ["profile", "home-page", "system-unreachable"],
      component: ProfileReview,
    },
  },
}
